import { Dashboard } from '../../common/components/dashboards/types';
import { Domains } from '../../constants';
import { Hasher } from '../hasher';
import { DomainSettings, HasDependencies, hashString } from '../types';

export class DomainViewAuthorizationService implements HasDependencies {
  constructor(
    readonly domain: Domains,
    readonly latestSettings: DomainSettings
  ) {}

  public getDeps = (): (string | undefined)[] => [
    hashString([this.domain, Hasher.hash(this.latestSettings)]),
  ];

  public isDashboardAllowed = (dashboard: Dashboard) => {
    const domainAllowedDashboards: string[] =
      this.latestSettings?.allowedDashboards?.map((d) => d.id) ?? [];
    return domainAllowedDashboards.includes(dashboard.id);
  };
}
